import { useKeycloak } from '@react-keycloak/web';

import { AuthRole } from 'types';

export const useIsRoleAllowed = (role: AuthRole) => {
  const { keycloak } = useKeycloak();

  return keycloak.tokenParsed?.realm_access?.roles.includes(role) || false;
};
